
class AuthenticationManager {
    constructor() {
        this.user = null;
        this.listeners = new Set();
    //    this.init();
    }

    async init() {
        await this.checkSession();
    }

    isSessionActive() {
        return this.user !== null;
    }
    async checkSession() {
        try {
            const response = await fetch('/api/security/status', {
                method: 'GET'
            });

            if (response.ok) {
                this.set(await response.json());
            } else {
                this.clear();
            }
        } catch (error) {
            alert('error');
            console.error('Error checking session:', error);
            this.clear();
        }
    }

    set(userData) {
        if (!userData || !userData.name) {
            this.clear();
            return;
        }
        this.user = {
            name: userData.name,
            role: userData.role
        };
        this.notifyListeners('login', this.user);
    }
    clear() {
        if (this.user === null) return;

        this.user = null;
        this.notifyListeners('logout');
    }

    async login(username, password) {
        try {
            const response = await fetch('/api/security/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
            });

            const data = await response.json();

            if (response.ok) {
                await this.checkSession();
                return { success: true };
            } else {
                return {
                    success: false,
                    error: data.message || 'Invalid credentials'
                };
            }
        } catch (error) {
            console.error('Login error:', error);
            return {
                success: false,
                error: 'Network error or server unavailable'
            };
        }
    }

    async logout() {
        try {
            await this.fetchWithAuthentication('/api/security/logout', { method: 'POST' });
        } catch (error) {
            console.error('Logout request failed, clearing session locally.', error);
        } finally {
            this.clear();
        }
    }
    async fetchWithAuthentication(url, options = {}) {
        const response = await fetch(url, options);
        if (response.status === 401) {
            this.clear();
            console.error('Authentication required. Session cleared.');
        }

        return response;
    }

    hasRole(role) {
        return this.user && this.user.role === role;
    }

    hasAnyRole(roles) {
        return this.user && Array.isArray(roles) && roles.includes(this.user.role);
    }

    getCurrentUser() {
        return this.user;
    }
    addListener(callback) {
        this.listeners.add(callback);
        return () => this.listeners.delete(callback); // Return an unsubscribe function.
    }

    notifyListeners(event, data) {
        this.listeners.forEach(callback => {
            try {
                callback(event, data);
            } catch (error) {
                console.error('Error in auth listener:', error);
            }
        });
    }
}

// Export only the singleton instance to enforce its use across the application.
// This prevents multiple, out-of-sync authentication managers from being created.
export default new AuthenticationManager();